export const POWERBI_CCMR_INTERNAL_VIEW =  "powerbi.ccmr_internal.view";
export const POWERBI_DQ_INSIGHTS_VIEW =  "powerbi.dq_insights.view";
export const POWERBI_CCMR_SLA_REPORTING_VIEW =  "powerbi.ccmr_sla_reporting.view";
export const POWERBI_OPERATIONAL_DASHBOARD_VIEW =  "powerbi.operational_dashboard.view";
export const POWERBI_CLIENT_DASHBOARD_VIEW =  "powerbi.client_dashboard.view";
export const ADMIN_CONTESTED_CASE_FORMS_EDIT =  "admin.contested_case_forms.edit";

export const ADMIN_PERMISSION_VIEW = "admin.permissions.view";
export const ADMIN_PERMISSION_EDIT = "admin.permissions.edit";
export const ADMIN_FIRM_EDIT = "admin.firms.edit";
export const LS_DOCUMENTS_VIEW = "ls.documents.view";
export const LS_DOCUMENTTYPE_ALIAS_MAPPING = "ls.documents.alias-mapping"

// SQL VIEW
export const CUSTOM_SQL_VIEW = "custom.sql.view";

// Semantic Layer
export const SEMANTIC_LAYER_ACCESS = "semantic.layer.access";

// Custom Reports
export const CUSTOM_EXPORTS_ACCESS = "custom.exports.access";

// Datasets
export const DATASETS_ACCESS = "custom.datasets.access";

// Templates
export const TEMPLATES_ACCESS = "custom.templates.access";

// Run History
export const RUN_HISTORY_ACCESS = "custom.runhistory.access";